'use strict';

define('$window', function () {
  window.nextUUID = window.nextUUID || 0;
  window.getUUID = function (id) {
    return '' + (id || '') + window.nextUUID++;
  };
  window.resetUUID = function () {
    window.nextUUID = 0;
  };
  return window;
});
//# sourceMappingURL=window.js.map
